var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _c("div", { staticClass: "ranking__detail__table ranking" }, [
          _vm._m(0),
          _c("div", { staticClass: "visual-responsive" }, [
            _c(
              "ul",
              { staticClass: "v2-lazy-list" },
              _vm._l(_vm.data, function(item, i) {
                return _c("li", { staticClass: "lazy-list-item" }, [
                  _c("span", [_vm._v(_vm._s(i + 1))]),
                  _c("h3", [_vm._v(_vm._s(item.Seller))]),
                  _c("em", [_vm._v(_vm._s(item.CountRecord))])
                ])
              })
            )
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-visual-responsive" }, [
      _c("div", { staticClass: "visual-responsive-head" }, [
        _c("h3", [_vm._v("Vendedores")]),
        _c("h4", [_vm._v("Total Afiliaciones")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2da44ab8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da44ab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ranking-mobile-table.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2da44ab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ranking-mobile-table.vue
// module chunks = 0 1